module.exports = new __parcel__URL__("shopkeeper-cedric.dcf764b0.webp").toString();